export default __webpack_public_path__ + "static/media/kk-incorrect.1cefee66.png";